import "./LocalSeoConsultantDoncaster.module.css";
import Header from "@/reusable_sections/Header";
import Localhero from "./sections/Localhero";
import Services from "./sections/Services";
import Casestudies from "./sections/Casestudies";
import Sectors from "./sections/Sectors";
import Doncaster from "./sections/Doncaster";
import Methodology from "./sections/Methodology";
import Consultation from "./sections/Consultation";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import Doncasterlocalseofaq from "./sections/Doncasterlocalseofaq";
import DoncasterMarket from "./sections/DoncasterMarket";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantDoncasterPage() {
  return <div>
      <Header />
      <Localhero />
      <Services />
      <Casestudies />
      <Sectors />
      <Doncaster />
      <Methodology />
      <Consultation />
      <ConsultantBenefits />
      <Doncasterlocalseofaq />
      <DoncasterMarket />
      <Footer />
    </div>;
}